import { Container } from "./styles";
import emailIcon from "../../assets/email-icon.png";
import telegramIcon from "../../assets/telegram.svg";
import { Form } from "../Form/Form";


export function Contact(){

  return(
    <Container id="contact">
      <header>
        <h2>Contact</h2>
        <p>Have a great idea? </p>
        <p>Contact me today for a professional consultation.</p>
      </header>
      <div className="contacts">
        <div>
        <a href="mailto:hello@adamfisher.xyz"><img src={emailIcon} alt="Email" /></a> 
          <a href="mailto:hello@adamfisher.xyz">hello@adamfisher.xyz</a>
        </div>
        <div>
        <a href="https://t.me/agoat0"><img src={telegramIcon} alt="Telegram" /></a>
          <a href="https://t.me/agoat0">@agoat0</a>
        </div>
      </div>
      <Form></Form>
    </Container>
  )
}